import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import moment from "moment";
import styles from "./../../style.module.scss";

import { useTranslation } from "react-i18next";
import { Button, message, Row, Col, Form, Input, Card, Grid } from "antd";
import { BiEdit, BiNavigation } from "react-icons/bi";

// redux & query
import { useAppSelector, useAppDispatch } from "store/hook";
import {
  setTicketVisible,
  setInspectModalVisible,
  setReportIssueModalVisible,
  setRemoveDeviceModalVisible,
} from "../../goSlice";

// components & Utils
import InspectModal from "./Inspect_Modal";
import ReportIssueModal from "./ReportIssue_Modal";
import FinishedModal from "./Finished_Modal";
import ExpiredModal from "./Expired_Modal";
import RemoveModal from "./Remove_Modal";
import { TimestampToDateM, ConnectionTime } from "Utility/Fetch";

const { useBreakpoint } = Grid;

interface formValueInterface {
  token: string;
}

// O'smart GO (工單頁面)

function Data(props: any) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { ticket } = useParams();
  const screens = useBreakpoint();

  const dispatch = useAppDispatch();
  const { level, isLogin, time_zone } = useAppSelector((state) => state.global);
  const { deviceId, ticketData, inspectModalVisible, removeDeviceModalVisible } = useAppSelector(
    (state) => state.goPage
  );

  const navigateGoogleMap = (lat: any, long: any) => {
    window.open(`https://maps.google.com/maps?daddr=${lat},${long}&amp;ll=`);
  };

  const goBackButton = () => {
    return (
      <Col>
        <Button
          type="primary"
          htmlType="button"
          className={styles.goBackButton}
          onClick={() => navigate("/maintenance")}
        >
          {t("ISMS.GoBack")}
        </Button>
      </Col>
    );
  };

  return (
    <>
      {/* 避免 inspect query 抓到 init 的 deviceId 空值 */}
      {deviceId !== "" && inspectModalVisible && <InspectModal />}
      <ReportIssueModal />
      <FinishedModal />
      <ExpiredModal />
      <RemoveModal deviceId={deviceId} />
      {ticketData?.node_inf.hasOwnProperty(deviceId) ? (
        // if has the id then render -> ticketData.node_inf[`${id}`]
        <>
          <Card className={styles.relative}>
            <div className={styles.editDiv}>
              <Button
                type="text"
                size={"large"}
                className={styles.iconButton}
                onClick={() => {
                  dispatch(setTicketVisible(true));
                }}
              >
                <BiEdit />
              </Button>
            </div>
            <Row gutter={[8, 0]}>
              <Col flex={!screens.xs ? "0 1 160px" : ""} className={styles.headerColumn}>
                {t("ISMS.LastUpdate")} :
              </Col>
              <Col flex={!screens.xs ? "1 1 100px" : ""}>
                {ticketData.node_inf[deviceId].latest_update === 0
                  ? ""
                  : TimestampToDateM(
                      ticketData.node_inf[deviceId].latest_update * 1000,
                      Intl.DateTimeFormat().resolvedOptions().timeZone || time_zone,
                      true
                    )}
              </Col>
            </Row>

            <Row gutter={[8, 0]}>
              <Col flex={!screens.xs ? "0 1 160px" : ""} className={styles.headerColumn}>
                {t("ISMS.LatestConnectionTime")} :
              </Col>
              <Col flex={!screens.xs ? "1 1 100px" : ""}>
                {
                  // (() => {
                  //   let seconds = ticketData.node_inf[deviceId].latest_connection;
                  //   let daySec = 24 * 60 * 60;
                  //   let hourSec = 60 * 60;
                  //   let minuteSec = 60;
                  //   let dd = Math.floor(seconds / daySec);
                  //   let hh = Math.floor((seconds % daySec) / hourSec);
                  //   let mm = Math.floor((seconds % hourSec) / minuteSec);
                  //   let ss = seconds % minuteSec;
                  //   if (dd > 0) {
                  //     return (
                  //       dd +
                  //       "天 " +
                  //       hh.toString().padStart(2, "0") +
                  //       ":" +
                  //       mm.toString().padStart(2, "0") +
                  //       ":" +
                  //       ss.toString().padStart(2, "0")
                  //     );
                  //   } else if (hh > 0) {
                  //     return (
                  //       hh.toString().padStart(2, "0") +
                  //       ":" +
                  //       mm.toString().padStart(2, "0") +
                  //       ":" +
                  //       ss.toString().padStart(2, "0")
                  //     );
                  //   } else if (mm > 0) {
                  //     return mm.toString().padStart(2, "0") + ":" + ss.toString().padStart(2, "0");
                  //   } else {
                  //     return ss.toString().padStart(2, "0") + "秒";
                  //   }
                  // })()
                  ticketData.node_inf[deviceId].latest_update === 0
                    ? ""
                    : ConnectionTime(ticketData.node_inf[deviceId].latest_update, t("ISMS.Day"), t("ISMS.Second"))
                }
              </Col>
            </Row>

            <Row gutter={[8, 0]}>
              <Col flex={!screens.xs ? "0 1 160px" : ""} className={styles.headerColumn}>
                {t("ISMS.Location")} :
              </Col>

              {ticketData.node_inf[deviceId].location && (
                <Col flex={!screens.xs ? "1 1 100px" : ""}>
                  <Row align="middle">
                    <Col>{ticketData.node_inf[deviceId].location}</Col>
                    {/* <Col style={{ height: 22 }}>
                      <Button
                        type="text"
                        size={"large"}
                        className={styles.iconButton}
                        onClick={() =>
                          navigateGoogleMap(
                            ticketData.node_inf[deviceId]["lat_long"][0],
                            ticketData.node_inf[deviceId]["lat_long"][1]
                          )
                        }
                      >
                        <BiNavigation className={styles.iconSize} />
                      </Button>
                    </Col> */}
                  </Row>
                </Col>
              )}
            </Row>

            <Row gutter={[8, 0]}>
              <Col flex={!screens.xs ? "0 1 160px" : ""} className={styles.headerColumn}>
                {t("ISMS.Name")} :
              </Col>
              <Col flex={!screens.xs ? "1 1 100px" : ""}>{ticketData.node_inf[deviceId].name}</Col>
            </Row>

            <Row gutter={[8, 0]}>
              <Col flex={!screens.xs ? "0 1 160px" : ""} className={styles.headerColumn}>
                GPS :
              </Col>
              {ticketData.node_inf[deviceId]["lat_long"] && (
                <Col style={{ height: 22 }} flex={!screens.xs ? "1 1 100px" : ""}>
                  {`${ticketData.node_inf[deviceId]["lat_long"][0].toFixed(9)},
                  ${ticketData.node_inf[deviceId]["lat_long"][1].toFixed(9)}`}
                  <Button
                    type="text"
                    size={"small"}
                    className={styles.iconButton}
                    onClick={() =>
                      navigateGoogleMap(
                        ticketData.node_inf[deviceId]["lat_long"][0],
                        ticketData.node_inf[deviceId]["lat_long"][1]
                      )
                    }
                  >
                    {/* <BiNavigation className={styles.iconSize} /> */}
                    <BiNavigation />
                  </Button>
                </Col>
              )}
            </Row>

            <Row gutter={[8, 0]}>
              <Col flex={!screens.xs ? "0 1 160px" : ""} className={styles.headerColumn}>
                {t("ISMS.Health")} :
              </Col>
              <Col flex={!screens.xs ? "1 1 100px" : ""}>
                {ticketData.node_inf[deviceId].health === "up"
                  ? "Good"
                  : ticketData.node_inf[deviceId].health.charAt(0).toUpperCase() +
                    ticketData.node_inf[deviceId].health.slice(1)}
              </Col>
            </Row>

            <Row gutter={[8, 0]}>
              <Col flex={!screens.xs ? "0 1 160px" : ""} className={styles.headerColumn}>
                {t("ISMS.Signal")} :
              </Col>
              <Col flex={!screens.xs ? "1 1 100px" : ""}>
                {ticketData.node_inf[deviceId].signal.charAt(0).toUpperCase() +
                  ticketData.node_inf[deviceId].signal.slice(1)}
              </Col>
            </Row>

            {ticketData?.ticket_inf?.ticket_type === "inspection" && (
              <Row gutter={[16, 8]} justify="center" style={{ marginTop: 20 }}>
                <Col>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={() => {
                      dispatch(setInspectModalVisible(true));
                    }}
                    disabled={ticketData.node_inf[deviceId].health === "offline" ? true : false}
                  >
                    {t("ISMS.Inspect")}
                  </Button>
                </Col>
                <Col>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={() => {
                      dispatch(setReportIssueModalVisible(true));
                    }}
                  >
                    {t("ISMS.ReportIssue")}
                  </Button>
                </Col>
                <Col>
                  <Button
                    type="primary"
                    htmlType="button"
                    disabled
                    // danger
                    // onClick={() => navigate("/maintenance")}
                  >
                    {t("ISMS.Replace")}
                  </Button>
                </Col>
              </Row>
            )}

            {ticketData?.ticket_inf?.ticket_type === "installation" && (
              <Row gutter={[16, 8]} justify="center" style={{ marginTop: 20 }}>
                <Col>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={() => {
                      dispatch(setRemoveDeviceModalVisible(true));
                    }}
                    danger
                  >
                    {t("ISMS.RemoveDevice")}
                  </Button>
                </Col>
              </Row>
            )}

            {/* {isLogin && <Row justify="center">{goBackButton()}</Row>} */}
          </Card>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default Data;
